interface ErrorStateProps {
  title?: string;
  message: string;
  className?: string;
}

export function ErrorState({ title = 'Erro', message, className = '' }: ErrorStateProps) {
  return (
    <div className={`theme-card border theme-border rounded-2xl p-6 ${className}`}>
      <div className="text-sm font-medium text-red-500 mb-1">{title}</div>
      <div className="text-sm theme-text-muted">{message}</div>
    </div>
  );
}
